var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud2Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 22.3,
    viewBox: "0 0 36 22.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.71,22.3a7.08,7.08,0,0,1-4.9-2.1A6.47,6.47,0,0,1,0,15.5,7.48,7.48,0,0,1,4.9,8.9a6.76,6.76,0,0,1,2.4-.4h.3a10.4,10.4,0,0,1,9-8.5h.7a10.28,10.28,0,0,1,9.3,5.9c.5,0,1-.1,1.4-.1a8.74,8.74,0,0,1,3.2.6A8.61,8.61,0,0,1,36,14.3a8.8,8.8,0,0,1-2.5,6.1,6.61,6.61,0,0,1-4.6,1.9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31,17.8a3.48,3.48,0,0,0,2.4,1h22.2a2.93,2.93,0,0,0,2.2-.9,5.12,5.12,0,0,0,1.5-3.7,5.34,5.34,0,0,0-2.7-4.7,4.69,4.69,0,0,0-1.7-.3,4.45,4.45,0,0,0-2,.4c-.2,0-.5.1-.7.1a1,1,0,0,1-.7-.2,1.45,1.45,0,0,1-.9-1.1,6.64,6.64,0,0,0-6.5-5h-.5a6.69,6.69,0,0,0-5.9,7,2,2,0,0,1-.4,1.3,1.74,1.74,0,0,1-1.2.6h-.6a5.68,5.68,0,0,0-1.3-.2,3,3,0,0,0-1.3.2,3.89,3.89,0,0,0-2.6,3.5,2.63,2.63,0,0,0,.7,1.9Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2Black);
export default __webpack_public_path__ + "static/media/cloud2_black.9568f7f93611cfbcf80e94f73fddb587.svg";
export { ForwardRef as ReactComponent };